module.exports = __webpack_public_path__ + "static/media/home.a687f736.png";